import React from 'react';

import COUNTRIES from '../../../../json/countries.json';

import SelectWidgetBase from './SelectWidgetBase';

import { CoreSelect } from '../../containers/';

import { MergeClassNames } from '../../../../../utils/';

/**
 * Select Country Container
 * @export
 * @class CoreSelectCountryContainer
 * @extends {SelectWidgetBase}
 */
export default class CoreSelectCountryContainer extends SelectWidgetBase {
  /**
   * SRC
   * @override
   * @static
   * @memberof CoreSelectCountryContainer
   */
  public static SRC = COUNTRIES;

  /**
   * Render
   * @returns
   * @memberof CoreSelectCountryContainer
   */
  public render() {
    const { options, props: { type, options: OPTIONS, value: VALUE, className: CLASSNAME, children, ...rest}} = this;

    let opts: CoreFormOptionsType = options.slice(0);

    /* istanbul ignore next */
    if (Array.isArray(OPTIONS) && OPTIONS.length) {
      opts = OPTIONS.concat(opts);
    }

    const clz = MergeClassNames(CLASSNAME, { countries: true });

    return <CoreSelect className={clz} options={opts} {...rest} />;
  }
}
